module.exports = __webpack_public_path__ + "img/zhanli-drop1.76f09648.png";